import { render, staticRenderFns } from "./svgWhatsapp.vue?vue&type=template&id=b535b91e&scoped=true"
import script from "./svgWhatsapp.vue?vue&type=script&lang=js"
export * from "./svgWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b535b91e",
  null
  
)

export default component.exports